import { gql } from '@apollo/client/index.js'
import { useContentful } from '@ecomm/shared-apollo'
import {
  type DuplexSectionSchema,
  duplexSectionSchema
} from '@ecomm/shared-sections'
import { useMemo } from 'react'

const DEFAULT_DUPLEX_SECTION_QUERY = gql`
  fragment ContentCollectionQWBaseFragment on QuoteWizard {
    __typename
    id: sys {id}
    sys {id}
    jebbitUrl
    type
    buttonText
  }

  fragment ContentCollectionQWExperienceFragment on NtExperience {
      id: sys {id}
      name: ntName
      type: ntType
      audience: ntAudience {
        id: sys {id}
        name: ntName
      }
      config: ntConfig
      variants: ntVariantsCollection(limit: 20) {
        items {
          ... on QuoteWizard {
            ...ContentCollectionQWBaseFragment
          }
        }
      }
    }

  query	Duplex_Section_Query($id: String!, $preview: Boolean!, $locale: String!) {
    duplex(id: $id, locale: $locale, preview: $preview) {
      __typename
      sys {id}
      id: sys {id}
      leftCollection {
        items {
          ... on Text {
            __typename
            sys {id}
            text {
              json
            }
            textAlignment
          }
          ... on ImageLink {
            __typename
            image {
              sys {id}
              __typename
              title
              url
              description
              originalWidth: width
              originalHeight: height
            }
          }
        }
      }
      rightCollection {
        items {
          ... on QuoteWizard {
            ...ContentCollectionQWBaseFragment
            ntExperiencesCollection(limit: 10) {
              items {
                ...ContentCollectionQWExperienceFragment
              }
            }
          }
          ... on Text {
            __typename
            sys {id}
            text {
              json
            }
          }
          ... on ImageLink {
            __typename
            image {
              sys {id}
              __typename
              title
              description
              url
              originalWidth: width
              originalHeight: height
            }
          }
        }
      }
    }
  }
`
export const useDuplexSectionQuery = (
  id: string,
  QUERY = DEFAULT_DUPLEX_SECTION_QUERY
): DuplexSectionSchema => {
  const { data: apolloData } = useContentful(QUERY, {
    id
  })

  const duplexSectionData = useMemo(
    () => duplexSectionSchema.parse(apolloData?.['duplex']),
    [apolloData]
  )

  return duplexSectionData
}
